<template>
    <div class="col-11">
        <div id="team-details-table" class="table-responsive">
            <table class="table">
                <thead class="thead-dark">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">HORSE</th>
                    <th scope="col">LTH BEHIND</th>
                    <th scope="col">SPEED INDEX</th>
                    <th scope="col">PREDICTED TIME</th>
                    <th scope="col">MR</th>
                    <th scope="col">MASS</th>
                    <th scope="col">DRAW</th>
                    <th scope="col">JOCKEY</th>
                    <th scope="col">TRAINER</th>
                </tr>
                </thead>
                <tbody>
                <tr v-bind:class="{'grey-background': (index < 4)}" v-for="(predictionItem, index) in predictedFinish" :key="index">
                    <td>{{predictionItem.horseNumber}}</td>
                    <td class="text-left">{{predictionItem.horseName}}</td>
                    <td>{{predictionItem.lengthsBehind | decimalpoint}}</td>
                    <td>{{predictionItem.speedIndex}}</td>
                    <td>{{predictionItem.predictedTime | decimalpoint}}</td>
                    <td>{{predictionItem.meritRating}}</td>
                    <td>{{predictionItem.mass}}</td>
                    <td>{{predictionItem.draw}}</td>
                    <td class="text-left">{{predictionItem.jockeyName | jockeyinit | init}}</td>
                    <td class="text-left">{{predictionItem.trainerName | init}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import jockeyTrainer from '../components/mixins/Jockey-TrainerName'
    export default {
        name: 'RaceCardPredictedFinish',
        mixins:[jockeyTrainer],
        data: function () {
            return {
            };
        },
        filters:{
           

            decimalpoint:function(value){
             value=value.toString()
                if(value!=null && !value.includes('.')){           
                return value +'.0'          
                }
                else if(value!=null && value.includes('.')){
                   return value       
                }
            }             
        },
        props: {
            predictedFinish: Array
        },
        methods: {
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            }
        },
        mounted: function() {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    table {
        border: 1px solid #7c7c7c !important;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
    }

    thead {
        background-color: #000000 !important;
        line-height: 0.7;
    }

    tr {
        text-align: center;
    }

    td {
        line-height: 0.9;
    }

    .grey-background {
        background-color: #DFDFDF !important;
    }
</style>
